import { render } from "./SidebarMenu1.vue?vue&type=template&id=df12397e&scoped=true"
import script from "./SidebarMenu1.vue?vue&type=script&lang=js"
export * from "./SidebarMenu1.vue?vue&type=script&lang=js"

import "./SidebarMenu1.vue?vue&type=style&index=0&id=df12397e&lang=scss&scoped=true"

import exportComponent from "../../../../../CASRA/saoil/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df12397e"]])

export default __exports__